// Seitenskript aus dem Design-Pack (Homepage.html, Inline-<script>).
// Nicht von Hand aendern, sondern dort und mit _build/skripte_ziehen.py neu ziehen.
document.addEventListener('DOMContentLoaded', function() {
            // Scroll reveal — sections fade in as you scroll
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                        if (entry.target.classList.contains('stagger-children')) {
                            setTimeout(() => entry.target.classList.add('settled'), 800);
                        }
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.1 });
            document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, .stagger-children').forEach(el => observer.observe(el));

            // Image tilt — subtle parallax on mouse move
            const tiltEl = document.querySelector('.img-tilt');
            if (tiltEl) {
                const container = tiltEl.closest('.aspect-square');
                if (container) {
                    container.addEventListener('mousemove', (e) => {
                        const rect = container.getBoundingClientRect();
                        const x = (e.clientX - rect.left) / rect.width - 0.5;
                        const y = (e.clientY - rect.top) / rect.height - 0.5;
                        tiltEl.style.transform = `perspective(800px) rotateY(${x * 4}deg) rotateX(${-y * 4}deg) scale(1.02)`;
                    });
                    container.addEventListener('mouseleave', () => {
                        tiltEl.style.transform = 'perspective(800px) rotateY(0) rotateX(0) scale(1)';
                    });
                }
            }
                    });

(function () {
    function animateCount(el) {
        var target = parseInt(el.getAttribute('data-target'), 10);
        var suffix = el.getAttribute('data-suffix') || '';
        var dur = 1800;
        var start = null;
        function frame(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased).toLocaleString('de-DE') + suffix;
            if (p < 1) requestAnimationFrame(frame);
        }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            el.textContent = target.toLocaleString('de-DE') + suffix;
            return;
        }
        requestAnimationFrame(frame);
    }
    var counted = new WeakSet();
    var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting && !counted.has(entry.target)) {
                counted.add(entry.target);
                animateCount(entry.target);
                obs.unobserve(entry.target);
            }
        });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-countup]').forEach(function (el) { obs.observe(el); });
})();
